import { contentFetch } from "../contentClient.js";
import {
    resolveScopedIdArgs,
    resolveScopedListArgs,
    resolveScopedMutationArgs,
    resolveScopedPayloadArgs,
    resolveScopedRenameArgs,
} from "./scope.js";

// ============= Parameters API (v2) =============

const base = (projectId, versionId) =>
    `/api/v2/projects/${projectId}/versions/${versionId}/parameters`;

export async function getParametersPaged({ projectId, versionId, search, valueType, isLocked, page = 1, pageSize, lang, include } = {}, init) {
    ({ args: { projectId, versionId, search, valueType, isLocked, page, pageSize, lang, include }, init } = resolveScopedListArgs({ projectId, versionId, search, valueType, isLocked, page, pageSize, lang, include }, init));
    const params = { page };
    if (pageSize) params.pageSize = pageSize;
    if (search?.trim()) params["filter.systemName:contains"] = search.trim();
    if (valueType) params["filter.valueType"] = valueType;
    if (isLocked != null) params["filter.isLocked"] = isLocked;
    if (lang) params.lang = lang;
    if (include) params.include = include;
    return contentFetch(base(projectId, versionId), { params, ...(init || {}) });
}

export async function getParameterById(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}`, init);
}

export async function createParameter(projectId, versionId, payload, init) {
    ({ projectId, versionId, payload, init } = resolveScopedPayloadArgs(projectId, versionId, payload, init));
    // payload:
    // {
    //   systemName: string,
    //   name: string,
    //   description?: string | null,
    //   valueType: "STRING" | "NUMERIC" | "BOOLEAN" | "ENUM" | "ARRAY" | "DATE" | "JSON",
    //   options?: any | null,
    //   defaultValue?: any | null
    // }
    return contentFetch(base(projectId, versionId), {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

export async function patchParameter(projectId, versionId, id, payload, init) {
    ({ projectId, versionId, id, payload, init } = resolveScopedMutationArgs(projectId, versionId, id, payload, init));
    // payload: { nameRefId?, descriptionRefId?, defaultValue?, options? }
    // isLocked=true: only nameRefId/descriptionRefId/defaultValue allowed
    return contentFetch(`${base(projectId, versionId)}/${id}`, {
        method: "PATCH",
        body: payload,
        ...(init || {}),
    });
}

export async function renameParameterSystemName(projectId, versionId, id, newSystemName, init) {
    ({ projectId, versionId, id, newSystemName, init } = resolveScopedRenameArgs(projectId, versionId, id, newSystemName, init));
    return contentFetch(`${base(projectId, versionId)}/${id}:rename`, {
        method: "POST",
        body: { newSystemName },
        ...(init || {}),
    });
}

export async function deleteParameter(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}`, {
        method: "DELETE",
        ...(init || {}),
    });
}
